import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-tdo-organizer-rename-dialog',
  templateUrl: './tdo-organizer-rename-dialog.component.html',
  styleUrls: ['./tdo-organizer-rename-dialog.component.scss']
})
export class TdoOrganizerRenameDialogComponent implements OnInit {
  title = 'Rename Folder';
  input: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<TdoOrganizerRenameDialogComponent>) {
    if (data.isNew) {
      this.title = 'Enter Folder Name';
    }

    if (data.name) {
      this.input = data.name;
    }
  }

  ngOnInit(): void {

  }

  onApply() {
    this.dialogRef.close(this.input);
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  get isChanged() {
    return this.input.length > 0;
  }
}
